<template>
  <div>
    <page-header
      :title="$t('aice.app_llm')"
      isShowResStatusTab
      :status-opts="statusOpts"
      :status-click-handle="statusClickHandle" />
    <page-body>
      <list
        :id="listId"
        :filterParams="filterParams"
        statusResKey="server"
        @resStatisticsChange="resStatisticsChange" />
    </page-body>
  </div>
</template>

<script>
import List from '@Ai/views/llm/components/List'
import ResStatisticsV2Mixin from '@/mixins/resStatisticsV2Mixin'

export default {
  name: 'AppLlmIndex',
  components: {
    List,
  },
  mixins: [ResStatisticsV2Mixin],
  data () {
    return {
      listId: 'AppLlmList',
      statusNormalList: ['running', 'ready'],
    }
  },
}
</script>
